import { equals } from 'lodash/fp'

export const getKeyFromValue =
  <T = unknown>(value: T) =>
  (obj: Record<string, T>) =>
    Object.keys(obj).find(key => equals(obj[key], value))
